import React, { useState } from "react";
import { RegisterContainer} from "../../containers"
import './style.scss'
function Register() {
    return (
        <div id="registerPage">
            <RegisterContainer />
        </div>
            
    );
}
export default Register;